import { sortByVisibilityCss } from "@/search/NewSearchPageMVP/FilterPanel/filters/SortBy/SortBy.styles";
import { SORT_BY_FILTER_OPTIONS } from "@/search/NewSearchPageMVP/NewSearchPageMVP.constants";
import { FilterSection } from "@/search/NewSearchPageMVP/shared/FilterSection";
import { AgathaSchemaParamsEnum } from "@/search/NewSearchPageMVP/types/IParametersSchema";
import { RadioFilter } from "../../../shared/RadioFilter";

export const SortBy = () => {
  return (
    <div css={sortByVisibilityCss}>
      <FilterSection title="Sort By" defaultCollapsed={false}>
        <RadioFilter
          options={SORT_BY_FILTER_OPTIONS}
          paramName={AgathaSchemaParamsEnum.sort_by}
        />
      </FilterSection>
    </div>
  );
};
